import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
  text: {
    margin: 0,
    '& span': {
      fontSize: 14,
    },
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },

  date: {
    margin: 0,
    paddingLeft: 10,
    '& span': {
      fontSize: 10,
      height: 12,
    },
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },

}));